<template>
  <v-container class="password-recovery pa-0">
    <v-row>
      <v-col cols="12" offset-md="3" md="6">
        <div class="card-head">
          <h2>Recover Password - Step 2</h2>
        </div>
        <div class="inputs">
          <v-text-field
            v-model="token"
            label="Token"
            filled
            @keyup.enter="recover"
          ></v-text-field>
          <v-text-field
            v-model="password"
            label="New password"
            type="password"
            filled
            :rules="rules.required.concat(rules.password)"
            @keyup.enter="recover"
          ></v-text-field>
        </div>
        <v-alert
          v-if="errorMessage"
          text
          type="error"
          class="pr-10"
        >
          {{ errorMessage }}
        </v-alert>
        <div class="controls">
          <v-btn
            x-large
            color="#f0b323"
            @click="recover"
            :disabled="!token || !password || isLoading"
          >
          Recover Password
          </v-btn>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import api from '@/services/api'

export default {
  name: 'password-recovery',
  data () {
    return {
      isLoading: false,
      token: '',
      password: '',
      errorMessage: '',
      valid: true,
      rules: {
        required: [
          value => !!value || 'Required'
        ],
        password: [
          value => value.length >= 8 || 'Minimum 8 characters'
        ]
      }
    }
  },
  mounted () {
    if (this.$route.query.token) {
      this.token = this.$route.query.token
    }
  },
  methods: {
    recover () {
      this.isLoading = true
      this.errorMessage = ''
      const { token, password } = this

      api
        .resetPasswordToken({ token, password })
        .then(res => {
          this.isLoading = false
          this.$emit('submitted')
          this.clearFields()
        })
        .catch(err => {
          this.isLoading = false
          this.errorMessage = err.response
            ? err.response.data.message
            : err.message
        })
    },
    clearFields () {
      this.token = ''
      this.password = ''
    }
  }
}
</script>

<style scoped lang="scss">
.password-recovery {
  position: relative;
  background: #fff;
  box-shadow: 0px 0px 14px rgba(59, 73, 86, 0.15);
  border-radius: 6px;
  margin-bottom: 50px;
}
.card-head {
  padding-left: 55px;
  padding-top: 50px;
}
.inputs {
  padding: 55px;
  padding-bottom: 0px;
}
.controls {
  display: flex;
  justify-content: space-between;
  padding: 20px 55px 50px;
  align-items: center;
}
</style>
